export default {
  codigo: {
    value: null,
    state: null
  },
  nome: {
    value: null,
    maxlength: '70',
    required: true,
    state: null,
    disabled: false
  },
  obraID: {
    value: null
  },
  funcionarioId: {
    value: null,
    code: null,
    options: [],
    state: null
  },
  funcaoObraID: {
    value: null,
    required: true,
    state: null
  },
  tipoMaoDeObra: {
    value: null,
    options: [
      {value: 1, text: 'Própria'},
      {value: 2, text: 'Terceiro'}
    ],
    state: null
  },
  inicioAtividades: {
    value: null,
    state: null
  },
  terminoAtividades: {
    value: null,
    state: null
  },
  tipoServico: {
    value: null,
    required: true,
    options: [
      {value: 1, text: 'Infra'},
      {value: 2, text: 'Instalação'},
      {value: 3, text: 'Outros'},
      {value: 4, text: 'Projeto'}
    ],
    state: null
  },
  observacoes: {
    value: null,
    options: [],
    state: null
  },
  status: {
    value: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/construction/member-form.js